/**
 * Busca de placa no portal — porta de entrada do histórico do veículo.
 * Lê o mesmo cadastro do BI; não cria nem edita veículo.
 */
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/api";
import { EmptyState } from "../../components/EmptyState";
import { IconTruck } from "../../components/icons";
import { portalPaths } from "../../features/portal/portal-nav";

export function PortalVehiclesPage() {
  const [q, setQ] = useState("");
  const navigate = useNavigate();

  const sugestoes = useQuery({
    queryKey: ["maintenance", "vehicles", q],
    queryFn: () => api.get<{ items: Array<{ plate: string; vehicleTypeName: string | null }> }>(`/maintenance/vehicles?q=${encodeURIComponent(q)}`),
    enabled: q.length >= 2,
  });

  return (
    <div className="space-y-4">
      <div>
        <h1 className="text-lg font-semibold text-gray-900">Veículos</h1>
        <p className="text-sm text-gray-500">Busque a placa para ver o histórico do veículo.</p>
      </div>

      <form
        onSubmit={(e) => { e.preventDefault(); if (q.length >= 7) navigate(portalPaths.vehicle(q)); }}
        className="flex gap-2"
      >
        <input
          className="input flex-1 uppercase font-mono text-lg"
          placeholder="ABC1D23"
          autoCapitalize="characters"
          value={q}
          onChange={(e) => setQ(e.target.value.toUpperCase().replace(/[^A-Z0-9]/g, ""))}
        />
      </form>

      {q.length >= 2 && (
        (sugestoes.data?.items.length ?? 0) === 0 && !sugestoes.isLoading ? (
          <div className="card">
            <EmptyState compact icon={<IconTruck className="w-5 h-5" />} title="Nenhuma placa encontrada"
              description="Confira a placa — a busca usa o cadastro de veículos da empresa." />
          </div>
        ) : (
          <div className="card divide-y divide-surface-border">
            {(sugestoes.data?.items ?? []).map((v) => (
              <Link key={v.plate} to={portalPaths.vehicle(v.plate)} className="px-4 py-3 min-h-[56px] flex items-center gap-3 hover:bg-surface-muted">
                <IconTruck className="w-4 h-4 text-gray-400" />
                <span className="font-mono font-medium text-gray-900">{v.plate}</span>
                {v.vehicleTypeName && <span className="text-xs text-gray-500">{v.vehicleTypeName}</span>}
              </Link>
            ))}
          </div>
        )
      )}
    </div>
  );
}
